module.exports = __webpack_public_path__ + "static/img/childTitle-three-one.cd9cc83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/childTitle-three-one.png
// module id = 78
// module chunks = 1